import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getLADRegionListEffect } from '../Claims/LossAndDamage/LossAndDamageClaimsEffects';
import { setLADClaimsRegionList } from '../common/CommonActions';

const useLADClaimsRegionList = (divisionKey) => {
  const [list, setList] = useState(undefined);
  const dispatch = useDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: fix this
  useEffect(() => {
    if (divisionKey) {
      getList();
    } else {
      setList([]);
    }
  }, [divisionKey]);

  const getList = async () => {
    try {
      dispatch(setLADClaimsRegionList({ data: [], success: true }));
      const { data } = await getLADRegionListEffect({ divisionKey });
      setList(data);
      dispatch(setLADClaimsRegionList({ data, success: true }));
    } catch {
      setList([]);
    }
  };

  return list;
};

export default useLADClaimsRegionList;
